import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    paperStyle: {
        margin: 0,
        boxShadow: 'none',
        backgroundColor: 'transparent'
    },
    dialogContainer: {
        padding: 0
    },
    closeButton: {
        position: 'absolute',
        right: 12,
        top: 28,
        color: theme.palette.grey[500],
        [theme.breakpoints.down('sm')]: {
            right: 6,
            top: 20,
            fontSize: 24
        }
    }
}))
